import React from "react";

export default function EditPatientModal({ show, onClose, selectedPatientForEdit, editPatientFullForm, setEditPatientFullForm, onSubmit, doctors }) {
  if (!show || !selectedPatientForEdit) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Edit Patient - {selectedPatientForEdit.name}</h2>
        <form onSubmit={onSubmit}>
          <div className="admin-row">
            <label>Name *</label>
            <input
              type="text"
              required
              value={editPatientFullForm.name}
              onChange={(e) => setEditPatientFullForm({...editPatientFullForm, name: e.target.value})}
            />
          </div>
          <div className="admin-row">
            <label>Doctor *</label>
            <select
              required
              value={editPatientFullForm.doctor_id}
              onChange={(e) => setEditPatientFullForm({...editPatientFullForm, doctor_id: e.target.value})}
            >
              <option value="">Select Doctor</option>
              {doctors.map(d => (
                <option key={d.user_id} value={d.user_id}>{d.display_name || d.user_name}</option>
              ))}
            </select>
          </div>
          <div className="admin-row">
            <label>Age</label>
            <input
              type="number"
              value={editPatientFullForm.age}
              onChange={(e) => setEditPatientFullForm({...editPatientFullForm, age: e.target.value})}
            />
          </div>
          <div className="admin-row">
            <label>Contact</label>
            <input
              type="text"
              value={editPatientFullForm.contact}
              onChange={(e) => setEditPatientFullForm({...editPatientFullForm, contact: e.target.value})}
            />
          </div>
          <div className="admin-row">
            <label>Address</label>
            <input
              type="text"
              value={editPatientFullForm.address}
              onChange={(e) => setEditPatientFullForm({...editPatientFullForm, address: e.target.value})}
            />
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
            <button type="submit" className="btn btn-primary">Update Patient</button>
            <button type="button" className="btn" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}
